<app-container class="container flex " ngClass.xs="xs" [maxWidth]=" '832px'" [sideMobilePadding]="'20px'">
  <header *ngIf="!handsetService.isMobile; else mobileHeader"  fxLayout="row"  style="margin-bottom: 40px">
    <div>
      <h1 class="header text-left">
        Dodaj nowy wydatek
      </h1>
      <p class="text-left">
        Wybierz sposób dodania wydatku do panelu. Po dodaniu będziesz mógł go odroczyć i zyskać więcej czasu na płatność.
      </p>
    </div>
    <div class="img-container">
      <img alt="Dodaj nowy wydatek" src="/assets/images/liabilities/add_new.svg" />
    </div>
  </header>
  <ng-template #mobileHeader>
    <header fxLayout="column">
      <h1 class="header text-left">
        Dodaj wydatek
      </h1>
      <p class="text-left">
        Wybierz sposób dodania wydatku do panelu. Po dodaniu będziesz mógł go odroczyć i zyskać więcej czasu na płatność.
      </p>
    </header>
  </ng-template>

  <div *ngIf="buttons" class="items-center">

    <div class="grid">
      <ng-container *ngFor="let button of buttons ; let isFirst = first">
        <app-new-tile-button
          [class.wide-item]="isFirst"
          [height]="handsetService.isMobile ? '160px': null"
          [title]="button.title"
          [subtitle]="button.subtitle"
          [icon]="button.icon"
          [iconSize]="handsetService.isMobile ?  (isFirst ? 32 : 20 )  : 32 "
          [disabled]="button.disabled"
          [onClickFn]="button.function"
          [bgColor]="button.bgColor"
          [bgHoverColor]="button.bgHoverColor"
        >
          <div *ngIf="isFirst" class="most-popular-banner" fxLayout="row">
            <app-icon
              [color]="'#575481'"
              [width]="18"
              [height]="19"
              [name]="'heart'"></app-icon>
            <span>Najczęściej wybierane</span>
          </div>


        </app-new-tile-button>
      </ng-container>
    </div>
  </div>
</app-container>
